import React from 'react';
import {Route, Switch, withRouter} from "react-router-dom";
import MessengerMobileRooms from "./MessengerMobile/MessengerMobileRooms";
import MessengerMobileRoomInfo from "./MessengerMobile/MessengerMobileRoomInfo";
import MessengerMobileRoom from "./MessengerMobile/MessengerMobileRoom";
import Helmet from "react-helmet";
import {config} from "../../../config";
import RoomCreate from "./RoomCreate";

const MessengerRouterMobile = ({match}) => {
    return (
        <div id="messenger">
            <Helmet>
                <title>{config.preTitle}Chat {config.postTitle}</title>
            </Helmet>
            <div className="layout-sidebar">
                <Switch>
                    <Route exact path={`${match.url}`} component={MessengerMobileRooms}/>
                    <Route exact path={`${match.url}/new`} render={(props) => <RoomCreate mobile={true} {...props}/>}/>
                    <Route exact path={`${match.url}/:room`} component={MessengerMobileRoom}/>
                    <Route exact path={`${match.url}/:room/infos`} component={MessengerMobileRoomInfo}/>
                </Switch>
            </div>
        </div>
    )
}

export default withRouter(MessengerRouterMobile);